import { PositionConfigInfo, TypeArgument, USDC } from '@kunalabs-io/kai'

import { useTokenPrice } from 'utils/useTokenPrice'
import { PositionCreationValues } from '../types'

export const useLpSizeUsdValue = (
  configInfo: PositionConfigInfo<string, string, TypeArgument>,
  positionCreationValues?: PositionCreationValues
) => {
  const { price: priceX } = useTokenPrice(configInfo.X, USDC)
  const { price: priceY } = useTokenPrice(configInfo.Y, USDC)

  const lpSizeX = positionCreationValues?.info.X
  const lpSizeY = positionCreationValues?.info.Y

  if (!lpSizeX || !lpSizeY || !priceX || !priceY) {
    return null
  }

  const lpSizeXUsd = lpSizeX.toNumber() * priceX.human.toNumber()
  const lpSizeYUsd = lpSizeY.toNumber() * priceY.human.toNumber()
  const lpSizeTotalUsd = lpSizeXUsd + lpSizeYUsd

  return Math.round(lpSizeTotalUsd * 100) / 100
}
